export default __webpack_public_path__ + "static/media/luciano.6b24cd11.jpg";